import { MFAMethodType } from 'types/mfa';

export const mfaMethodLabels: Record<MFAMethodType, string> = {
  [MFAMethodType.EMAIL]: 'Email',
  [MFAMethodType.TOTP]: 'Authenticator App',
  [MFAMethodType.SMS]: 'SMS',
  [MFAMethodType.WHATSAPP]: 'WhatsApp',
};

// Stytch returns the same delivery error types for SMS and WhatsApp, so anything user facing has
// to name the channel the user actually picked.
const deliveryLabels: Partial<Record<MFAMethodType, string>> = {
  [MFAMethodType.SMS]: 'SMS',
  [MFAMethodType.WHATSAPP]: 'WhatsApp messages',
};

const deliveryLabel = (method: MFAMethodType): string => deliveryLabels[method] ?? 'verification codes';

export const getUnsupportedCountryMessage = (method: MFAMethodType): string =>
  `We do not support sending ${deliveryLabel(method)} to your country yet. Please use a different authentication method.`;

const phoneOTPErrorMessages: Record<string, (method: MFAMethodType) => string> = {
  invalid_phone_number_country_code: getUnsupportedCountryMessage,
  duplicate_phone_number: () => 'This phone number is already registered. Please use a different phone number.',
  duplicate_phone_number_for_user: () =>
    'This phone number is already registered. Please use a different phone number.',
  invalid_phone_number: () => 'Please enter a valid phone number.',
  unsubscribed_phone_number: (method) =>
    method === MFAMethodType.WHATSAPP
      ? 'You have unsubscribed from WhatsApp messages. Please resubscribe before messages can be sent.'
      : `You have unsubscribed from SMS notifications. Please resubscribe by texting 'START' before messages can be sent.`,
  insufficient_factors: () => 'You already seem to have an auth factor registered. Please contact support.',
  user_unauthenticated: () => 'Your session has expired. Please login again.',
};

export const getPhoneOTPErrorMessage = (errorType: string, method: MFAMethodType, fallback: string): string =>
  phoneOTPErrorMessages[errorType]?.(method) ?? fallback;
